import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteMoneyAccountFormModal from 'src/features/moneyAccounts/components/forms/DeleteMoneyAccountFormModal';
import { MoneyAccount } from 'src/features/moneyAccounts/utils/types';
import UpdateMoneyAccountFormModal from 'src/features/moneyAccounts/components/forms/UpdateMoneyAccountFormModal';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';

export default function CellMoneyAccountActions({ row }: CellContext<MoneyAccount, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateMoneyAccountFormModal
                        semantics={{ entryName: formatMessage(moneyAccountsMessages.account).toLowerCase() }}
                        selectedMoneyAccount={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateMoneyAccountFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteMoneyAccountFormModal selectedMoneyAccount={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteMoneyAccountFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
